module.exports = __webpack_public_path__ + "static/media/icn-group-white.65ff6041.svg";